module.exports = __webpack_public_path__ + "static/media/syn-favicon.74b887d5.ico";